import React from 'react';
import { Section } from './ui/Section';
import { ArrowDown, Check } from 'lucide-react';
import { motion } from 'framer-motion';
export default function ResultSection() {
  const steps = ['Te acuestas sin miedo a pensar.', 'Tu mente se calma en minutos, no horas.', 'Te duermes sin darte cuenta.', 'Te despiertas con energía real.', 'Vuelves a ser tú mismo durante el día.'];
  return <Section className="bg-brand-charcoal relative overflow-hidden" data-id="element-361">
      <div className="absolute inset-0 bg-gradient-to-t from-brand-indigo/5 to-transparent pointer-events-none" data-id="element-362" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-363">
        <h2 className="font-heading text-4xl md:text-5xl text-white mb-12 uppercase tracking-wide" data-id="element-364">
          Lo que pasará en 14 días:
        </h2>

        <div className="space-y-6 mb-16" data-id="element-365">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.15
        }} className="flex flex-col items-center" data-id="element-366">
              <div className="flex items-center gap-3" data-id="element-367">
                <motion.div initial={{
              scale: 0
            }} whileInView={{
              scale: 1
            }} transition={{
              delay: index * 0.15 + 0.2,
              type: 'spring'
            }} className="bg-brand-indigo/15 p-1 rounded-full" data-id="element-368">
                  <Check size={16} className="text-brand-indigo" data-id="element-369" />
                </motion.div>
                <p className={`text-2xl md:text-3xl font-light ${index >= 3 ? 'text-slate-200' : 'text-slate-500'}`} data-id="element-370">
                  {step}
                </p>
              </div>
              {index < steps.length - 1 && <ArrowDown className="text-brand-indigo/40 my-2" size={24} data-id="element-371" />}
            </motion.div>)}
        </div>

        <motion.div whileHover={{
        scale: 1.02
      }} className="bg-brand-dark p-8 rounded-2xl border border-brand-indigo/20 shadow-lg hover:shadow-xl transition-all duration-500" data-id="element-372">
          <p className="text-2xl md:text-3xl text-slate-200 font-heading mb-4 uppercase tracking-wide" data-id="element-373">
            Sin pastillas.{' '}
            <span className="text-brand-indigo font-bold" data-id="element-374">Sin pelear.</span>
          </p>
        </motion.div>
      </div>
    </Section>;
}